import { bundle } from '@scalar/openapi-parser';
import { parseJson, parseYaml } from '@scalar/openapi-parser/plugins-browser';
import { fetchURL } from './scalar-plugins/fetchURL';
import { fetchURLs } from './scalar-plugins/fetchURLs';
/**
 * Create a filesystem from an OpenAPI document.
 * Fetches all the URLs specified in references and builds a filesystem.
 */
export async function createFileSystem(input) {
    const { value, rootURL, options } = input;
    const result = await bundle(value, {
        treeShake: false,
        plugins: [
            fetchURL(),
            parseYaml(),
            parseJson(),
            fetchURLs({ rootURL }),
            ...(options?.plugins || []),
        ],
    });
    return [
        {
            dir: '.',
            isEntrypoint: true,
            references: [],
            filename: 'openapi.json',
            specification: result,
        },
    ];
}
